<app-slide id="nextOfKinSlide" title="Next of Kin"
    supportingText="Please provide us with contact details, in-case we ever need to contact them."
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'nextOfKin'"
    [slideCompleted]="formState.progress.nextOfKinComplete" *ngIf="formState.applicationForm === 'general'">

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
        {{ errorMessage }}
    </div>
    <!-- {{formState | json}} -->
    <div id="next-of-kin-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it again.</p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title}}, {{error.msg}}</a>
            </li>
        </ul>
    </div>

    <ng-container *ngIf="fields | async as fields">
        <div>
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            <div class="section ng-empty" *ngIf="showSubmit">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="form-group ">
                            <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                                <span>Back</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="position: relative;"
                                (click)="onSubmit()" (disabled)="isDisabled">
                                <span>Save &amp; Continue Securely</span>
                                <app-spinner *ngIf="submitting" class="signupSubmitSpinner"></app-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</app-slide>